export default __webpack_public_path__ + "static/media/151-disturbance.fc40e510.png";